import { createGlobalStyle } from 'styled-components';
import { Media } from 'src/constants';
import { theme } from './theme';

const GlobalStyle = createGlobalStyle(() => ({
  body: {
    margin: 0,
    padding: 0,
    fontFamily: 'Open-Sans, Helvetica, Sans-Serif',
    fontSize: '1rem',
    color: theme.colors.darkGrey,
    backgroundColor: theme.colors.white,

    p: {
      marginTop: '0 !important',
      marginBottom: '8px',
      fontFamily: 'Roboto',
      fontWeight: theme.fontWeights.light,
      fontSize: theme.fontSizes[1],
      textAlign: 'left',
      width: '100%',
      img: {
        maxWidth: '100%',
        display: 'block',
        margin: '0 auto',
      },
      a: {
        color: theme.colors.black,
        cursor: 'pointer',
        textUnderlineOffset: '2px',
        ':link': {
          color: theme.colors.black,
        },
        ':visited': {
          color: theme.colors.black,
        },
        ':hover': {
          textDecoration: 'underline',
          color: theme.colors.blue,
        },
      },
    },
    li: {
      marginTop: '0 !important',
      marginBottom: '8px',
      fontFamily: 'Roboto',
      img: {
        maxWidth: '100%',
        display: 'block',
        margin: '0 auto',
      },
    },
    h1: {
      textAlign: 'center',
      fontWeight: theme.fontWeights.bold,
      textTransform: 'uppercase',
      fontFamily: 'Montserrat',
      fontSize: theme.fontSizes[6],
      [Media.desktop]: {
        fontSize: theme.fontSizes[7],
      },
    },
    h2: {
      textAlign: 'center',
      fontWeight: theme.fontWeights.bold,
      textTransform: 'uppercase',
      fontFamily: 'Montserrat',
      fontSize: theme.fontSizes[5],
      [Media.desktop]: {
        fontSize: theme.fontSizes[6],
      },
    },
    h3: {
      textAlign: 'center',
      fontWeight: theme.fontWeights.regular,
      textTransform: 'uppercase',
      fontFamily: 'Montserrat',
      fontSize: theme.fontSizes[4],
      [Media.desktop]: {
        fontSize: theme.fontSizes[5],
      },
    },
    h4: {
      textAlign: 'center',
      fontSize: theme.fontSizes[2],
      fontWeight: theme.fontWeights.regular,
      textTransform: 'uppercase',
      fontFamily: 'Montserrat',
      [Media.desktop]: {
        fontSize: theme.fontSizes[3],
      },
    },
    h5: {
      textAlign: 'center',
      fontWeight: theme.fontWeights.regular,
      textTransform: 'uppercase',
      fontFamily: 'Montserrat',
      fontSize: theme.fontSizes[1],
      [Media.desktop]: {
        fontSize: theme.fontSizes[2],
      },
    },
    h6: {
      textAlign: 'center',
      fontWeight: theme.fontWeights.regular,
      textTransform: 'uppercase',
      fontFamily: 'Montserrat',
      fontSize: theme.fontSizes[0],
      [Media.desktop]: {
        fontSize: theme.fontSizes[1],
      },
    },
  },
}));

export default GlobalStyle;
